import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

import { esnContactHref, type EsnContactChannel, type EsnContactFact } from '../../../shared/types/support';
import { ButtonComponent } from '../../atoms/button/button.component';

/**
 * The Help Center "Talk to us" aside: how to reach support, the facts support will ask for
 * (who is signed in, which organisation, which scope) and a way into the guided tour.
 */
@Component({
  selector: 'esn-contact-card',
  imports: [ButtonComponent],
  templateUrl: './contact-card.component.html',
  styleUrl: './contact-card.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContactCardComponent {
  readonly heading = input('');
  readonly description = input('');
  readonly channels = input<EsnContactChannel[]>([]);
  readonly facts = input<EsnContactFact[]>([]);

  /**
   * Line above the tour button; the tour block hides when `tourLabel` is empty.
   */
  readonly tourText = input('');
  readonly tourLabel = input('');

  readonly tourRequested = output<void>();

  protected readonly href = esnContactHref;
}
